import { FC } from 'react'
import styled from 'styled-components'
import OldChip from 'components/OldChip'
import { FilterByKeys } from '../../context'
import { TFilterChipItem } from './RecruitFilterChips.module'

interface IFRecruitFilterChipPcProps {
  fieldKey: FilterByKeys
  item: TFilterChipItem
  onClick: () => void
  className?: string
}

/**
 * TODO: 2 depth이상 컴포넌트기 때문에 해당 컴포넌트는 추후 수정합니다. 2023.07.05 장선규
 */
const RecruitFilterChipPc: FC<IFRecruitFilterChipPcProps> = ({
  fieldKey,
  item,
  onClick,
  className = '',
}) => {
  return (
    <StyledWrapper
      className={className}
      data-typeid={`${fieldKey}-${item.id}`}
      color="primary"
      size="small"
      onDelete={onClick}
      key={`${fieldKey}_${item.id}`}
      label={item.name}
    />
  )
}

export default RecruitFilterChipPc

const StyledWrapper = styled(OldChip)`
  height: 35px;
`
